// Profile.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./Profile.css";
import { logoutUser, ProfileUser } from "../../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { logout } from "../../Store/authSlice";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  
const dispatch=useDispatch()
  const[user,setUser]=useState()
  const navigate=useNavigate()


   const { isAuthenticated ,token} = useSelector((state) => state.auth);
  const handleGetProfile=async()=>{
    try {
        const res =await ProfileUser(token)
        console.log('handleGetProfile',res);
        setUser(res.data.data)
       console.log(isAuthenticated,user);
       
        
    } catch (error) {
       console.log(error);
        
    }
  }

  const handlerLogout=async()=>{
    try {
        console.log(token);
        
        const res =await logoutUser(token)
        console.log(res);
        if(res.status===200){
          toast.success("Loggedout successfully")
          dispatch(logout())
          navigate("/")
        }
        
    } catch (error) {
        console.log(error);
        toast.error("failed to logout")
        
    }
  }

  useEffect(() => {
    handleGetProfile()
  }, [])
  

  return (
    <div className="profile-container">
      <motion.div
        className="profile-card"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.img
          src={user?.profile_image||'/dp.png'}
          alt="Profile"
          className="profile-img"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: "spring" }}
        />

        <h2>{user?.full_name}</h2>
        <p><strong>Email:</strong> {user?.email}</p>
     
        <p><strong>Phone:</strong> {user?.phone}</p>


        <button onClick={()=>handlerLogout()}
            style={{marginTop:"20px"}}>Logout</button>
      </motion.div>
    </div>
  );
};

export default Profile;

